import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import ProfilesGrid from '../components/ProfilesGrid';

const ProfilePage = () => {
  return (
    <>
      <h2 className="TitleGrid">
        <Trans>Profiles</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <ProfilesGrid />
    </>
  );
};

export default ProfilePage;
